<script lang="ts" setup>
import '@pkg/ui/components/ui/theme/app.css.ts';
import { ConfigProvider } from 'radix-vue';
import { useResourceHints } from '~/app/composables/useResourceHints';
const { meta, preconnect, preload } = useAppConfig();
const { public: { noIndex } } = useRuntimeConfig();

const useIdFunction = () => useId();

useResourceHints({
  preconnect,
  preload,
});

useHead({
  meta: [
    { name: 'google-site-verification', content: meta.googleSiteVerification },
    ...(noIndex ? [{ name: 'robots', content: 'noindex' }] : []),
  ],
  link: [{ rel: 'sitemap', title: 'Sitemap', href: '/sitemap.xml' }],
});

// Define fallbacks in case we can't load SEO data from CMS
useSeoMeta({
  title: meta.title,
  titleTemplate: `%s - ${meta.name}`,
  description: meta.description,
  ogType: 'website',
});

</script>

<template>
  <Body>
    <ConfigProvider :use-id="useIdFunction">
      <NuxtLayout>
        <NuxtLoadingIndicator />
        <NuxtPage />
      </NuxtLayout>
    </ConfigProvider>
  </Body>
</template>
